
import axios from 'axios'
// import store from '@/store'
// import * as types from '@/store/mutation-types'
// import router from '@/router'
import * as api from './api-const'


// axios 配置
axios.defaults.timeout = 20000

if(process.env.NODE_ENV === 'mock_server'){
    axios.defaults.baseURL = ""
}else{
    // 开发环境使用代理，baseURL 为空字符串（相对路径）
    // 生产环境使用完整的 API 地址
    axios.defaults.baseURL = api.baseRequestUrl || ''
}
// axios.defaults.baseURL = api.baseRequestUrl;
// http request 拦截器
axios.interceptors.request.use(
    config => {
        // 如果使用的是 FormData，不要设置 Content-Type，让浏览器自动设置
        // 否则会触发 CORS 预检请求
        if (!(config.data instanceof FormData)) {
            config.headers = {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        // if (Lockr.get('token')) { // 判断是否存在token，如果存在的话，则每个http header都加上token
        //     axios.defaults.headers.Authorization = Lockr.get('token')
        // }
        return config
    },
  err => {
      return Promise.reject(err)
  })
// 添加一个响应拦截器
axios.interceptors.response.use(function (res) {
    if (!res.data.success) {
        if(res.data.code=='410'){
            Util.setCookie('user_token','')
        }
        return res
    }
    return res
}, function (err) {
    return Promise.reject(err)
})

export default axios



// WEBPACK FOOTER //
// ./src/service/api/http.js